import { useTranslation } from "react-i18next";
import Image from "next/image";
import EducationalZone from "assets/img/landing/EducationalZone.png";
import GroundSensors from "assets/img/landing/GroundSensors.png";
import SatelliteImagerys from "assets/img/landing/SatelliteImagerys.png";
import WeatherForecast from "assets/img/landing/WeatherForecast.png";
import IrrigationAdvisoryEngine from "assets/img/landing/IrrigationAdvisoryEngine.png";
import DigitalTwin from "assets/img/landing/DigitalTwin.png";

function index() {
  const { t } = useTranslation();

  return (
    <div className="container m-auto py-15" id="Services">
      <div className="mx-5 md:mx-0">
        <div className="font-bold text-center text-3xl text-[#B3503A]">
          {t("AgTech SERVICES")}
        </div>
        <div className="flex flex-wrap items-start justify-center gap-10 mt-15">
          <div className="flex flex-col justify-between items-center md:w-5/12 lg:w-[calc(80%/3)]">
            <div className="bg-[#F7F7F7] rounded-lg w-[150px] h-[150px] flex items-center justify-center">
              <Image priority={true} quality={30} src={DigitalTwin} alt="img" />
            </div>
            <div className="text-[#B3503A] font-bold text-lg my-2">
              {t("Digital Twin")}
            </div>
            <div className="text-[#8B8B8B] text-center">
              {t(
                "It enables planning and following up on farm daily plans and tasks: agricultural operations, irrigation, pests and diseases, irrigation network, equipment operations, and field visits. It enables users to:"
              )}{" "}
              <br />
              {t(
                "1-Create a digital twin of all components: plots of land, plants, irrigation and electricity networks, sensors, equipment, stores, etc."
              )}{" "}
              <br />
              {t(
                "2-Build work/task plans for all activities inside the farm, and an engine within the system distributes and follows up on tasks daily."
              )}{" "}
              <br />
              {t(
                "3-Follow up on the daily workflow and detect the problems of the farm through the reporting engine."
              )}{" "}
              <br />
              {t(
                "4-Monitor the balance and consumables of fertilizers and seeds and the efficiency of human resources."
              )}{" "}
              <br />{" "}
              {t(
                "5-Receive Reports of crop/farm productivity and correlation with expenses/water/fertilizers application."
              )}
            </div>
          </div>
          <div className="flex flex-col justify-center items-center md:w-5/12 lg:w-[calc(80%/3)] ">
            <div className="bg-[#F7F7F7] rounded-lg w-[150px] h-[150px] flex items-center justify-center">
              <Image
                priority={true}
                quality={30}
                src={IrrigationAdvisoryEngine}
                alt="img"
              />
            </div>
            <div className="text-[#B3503A] font-bold text-lg my-2">
              {t("Irrigation Advisory Engine")}
            </div>
            <div className="text-[#8B8B8B] text-center">
              {t(
                "PLATFARM calculates the accurate water needs of plants daily, based on a scientific method using meteorological data, plant and soil type, and ground sensor data, if any."
              )}
              <br />
              <br />{" "}
              {t(
                "This feature builds a crop model from sowing/planting to harvesting and calculates the plant’s water needs successively."
              )}
              <br />
              <br />{" "}
              {t(
                "This feature saves from 20% - 30% of the cost of water and electricity/diesel per month, depending on the type of crop"
              )}
            </div>
          </div>
          <div className="flex flex-col justify-center items-center md:w-5/12 lg:w-[calc(80%/3)]">
            <div className="bg-[#F7F7F7] rounded-lg w-[150px] h-[150px] flex items-center justify-center">
              <Image
                priority={true}
                quality={30}
                src={WeatherForecast}
                alt="img"
              />
            </div>
            <div className="text-[#B3503A] font-bold text-lg my-2">
              {t("Weather Forecast & Spray Advisory")}
            </div>
            <div className="text-[#8B8B8B] text-center">
              {t(
                "PLATFARM provides weather forecast data daily and according to each farm’s location. It supports weather data like temperature, humidity, wind, and rain expected for a period of 7 days."
              )}
              <br /> <br />
              {t(
                "This feature also delivers daily evapotranspiration/ transpiration data for each farm, which has a pivotal role in determining the water needs of the plant."
              )}
              <br /> <br />
              {t(
                "The feature identifies the convenient time for spraying or pollination operations in order to avoid wasting pesticides and inappropriate pollination or spraying operations"
              )}
            </div>
          </div>
          <div className="flex flex-col justify-center items-center md:w-5/12 lg:w-[calc(80%/3)]">
            <div className="bg-[#F7F7F7] rounded-lg w-[150px] h-[150px] flex items-center justify-center">
              <Image
                priority={true}
                quality={30}
                src={SatelliteImagerys}
                alt="img"
              />
            </div>
            <div className="text-[#B3503A] font-bold text-lg my-2">
              {t("Satellite Imagery Processing Engine")}
            </div>
            <div className="text-[#8B8B8B] text-center">
              {t(
                "PLATFARM collects daily satellite images, processes several datasets then extracts:"
              )}{" "}
              <br /> {t("1- Monitoring plant growth and vegetation rates .")}
              <br />
              {t(
                "2- Early detection of crop stress areas due to irrigation/heat effect/disease outbreaks ."
              )}
              <br />
              {t("3- Monitor nitrogen levels within plant leaves.")}
              <br />
              {t("4- Monitor the vegetative mass formed daily.")}
              <br />
              {t("5- Forecasting the production rates and volumes.")}
              <br />
              {t("6- Compare field to field crop performance.")}
              <br />
              {t(
                "7- Reports on the performance of well-growing areas and areas with late growth for better distribution of fertilizers within a single field."
              )}
            </div>
          </div>
          <div className="flex flex-col justify-center items-center md:w-5/12 lg:w-[calc(80%/3)]">
            <div className="bg-[#F7F7F7] rounded-lg w-[150px] h-[150px] flex items-center justify-center">
              <Image
                priority={true}
                quality={30}
                src={GroundSensors}
                alt="img"
              />
            </div>
            <div className="text-[#B3503A] font-bold text-lg my-2">
              {t("Ground Sensors")}
            </div>
            <div className="text-[#8B8B8B] text-center">
              {t(
                "PLATFARM is empowered with a module that allows connecting sensors from several service providers, such as: Ground humidity sensors weather stations sensors Smart water meters Palm weevil sensors Leaves wetness sensors Equipment and machinery tracking devices"
              )}
              <br />
              <br />
              {t("Ground humidity sensors")} <br />
              {t("weather stations sensors")} <br />
              {t("Smart water meters")} <br />
              {t("Palm weevil sensors")} <br />
              {t("Leaves wetness sensors")} <br />
              {t("Equipment and machinery tracking devices")} <br />
              <br />
              {t(
                "The module can collect, store, and process sensors’ data. Through the platform, the user can view all the different sensor readings from the same interface from which he manages the different operations within the farm. "
              )}
            </div>
          </div>
          <div className="flex flex-col justify-center items-center md:w-5/12 lg:w-[calc(80%/3)]">
            <div className="bg-[#F7F7F7] rounded-lg w-[150px] h-[150px] flex items-center justify-center">
              <Image
                priority={true}
                quality={30}
                src={EducationalZone}
                alt="img"
              />
            </div>
            <div className="text-[#B3503A] font-bold text-lg my-2">
              {t("Educational Zone")}
            </div>
            <div className="text-[#8B8B8B] text-center">
              {t(
                "PLATFARM provides technical and agricultural educational zone with content for several different crops, prepared by agricultural specialists about:"
              )}
              <br />
              <br />
              {t(
                "Modern technologies in agriculture Various plant diseases, their symptoms, detection methods, prevention, and treatment methods."
              )}
              <br />
              {t(
                "Agricultural operations and sound agricultural practices from the beginning of cultivation to harvest"
              )}
              <br />
              {t(
                "harvest The content is prepared in a simplified way and supported by pictures and videos to raise the level of workers’ awareness within agriculture and provide them with what is new and specific to sound agricultural practices."
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
